<template>
    <vue-js-modal
      v-if="queue"
      :key="reload"
      id="agQueueModal"
      class="agModal"
      name="agQueueModal"
      draggable=".card-header"
      width="75%"
      height="85%"
      :shiftX=".5"
      :shiftY=".25"
      :resizable="true"
      :clickToClose="false">
      <b-card>
        <template #header>
          <h4 v-if="disableUI || isLoading" class="agModal-title">View Queue {{queue.shortname}}</h4>
          <h4 v-else class="agModal-title">Edit Queue {{queue.shortname}}</h4>      
        </template>

        <div class="agInputGroup agInputGroupCentered">
          <label>Source(s):</label>
          <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
        </div>
        <b-input-group size="md" style="padding:14px;" prepend="Name">
          <b-input type="text" v-model="queue.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
        </b-input-group>
        <b-input-group size="md" style="padding:14px;" prepend="Description">
          <b-input type="text" v-model="queue.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
        </b-input-group>
      <hr/>
        <input
          type="checkbox"
          v-model="queue.hasBreakpoint"
          :disabled="disableUI || isLoading"/>
        <label>Has Breakpoint</label>
        <hr>
        <div class="agInputGroup agInputGroupCentered">
          <label>Type:</label>
          <b-form-select 
            class="agMediumInput"
            v-model="queue.subtype" 
            :options="types" 
            :disabled="disableUI || isLoading">
          </b-form-select>
        </div>
        <div class="agInputGroup agInputGroupCentered">
          <label id="agQueueModal-typeDescription">{{typeDescription}}</label>
        </div>
        <hr>

        <!-- Components based on type -->

        <ag-queue-pause
          v-if="queue.subtype == 'pause'"
          ref="pause"
          :disableUI="disableUI || isLoading"
          :workflow="workflow"
          :queue="queue">
        </ag-queue-pause>

        <ag-queue-throttling
          v-if="queue.subtype == 'throttling'"
          ref="throttling"
          :disableUI="disableUI || isLoading"
          :workflow="workflow"
          :queue="queue">
        </ag-queue-throttling>      

      <div class="agInputGroup agInputGroupCentered">
        <label>Destination:</label>
        <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
      </div>

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>


    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Queue</h4>
      </template>
      Are you sure you want to delete queue
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">
          Cancel
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

  </vue-js-modal>
</template>


<script>

// components
import Pause from "nodes/queues/Pause";
import Throttling from "nodes/queues/Throttling";

// modules
import Vue from "vue";

export default {
    name: "ag-queue-modal",
    components: {
      "ag-queue-pause": Pause,
      "ag-queue-throttling": Throttling
    },
    props:{
        node: Object,
        workflow: Object,
        disableUI: Boolean
    },
    data(){
        return {
          queue: null,
          reload: 0,
          isLoading: false,
          modalMessage: "",
          modalMessageClass: "",
          types: [ 
            { value: "pause", text: "Pause", description: "Once each record reaches this node, processing will pause for the set number of seconds before continuing to the next node" },
            { value: "throttling", text: "Throttling", description: "Queues records wherever this node is placed in the flow and will release one record per the set number of milliseconds to continue processing." }
          ]
        };
    },
    computed: {

      name() {
        if (this.queue.name) 
          return this.queue.name;
      
        return this.queue.shortname;
      },

      srcStr() {
        if(!this.queue.src || this.queue.src.length == 0)
          return "";

        var srcStr = "";
        for(var i = 0; i < this.queue.src.length; i++)
        {
          var src = this.queue.src[i];
          srcStr += src.shortname + ", ";
        }
        srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last , 
        return srcStr;
      },

      destName() {
        if(this.queue.dest)
          return this.queue.dest.shortname;
        return "";
      },

      typeDescription() {
        var type = this.types.find((type) => type.value == this.queue.subtype);
        if(!type)
          return "";
        return type.description;
      }


    },
    methods:{

        // UI Events

        cancelButton_click() {
          this.hide();
        },

        async saveButton_click() {

          this.modalMessage = "";

           // alert subcomponent
          if(this.queue.subtype) {
            var subcomponent = this.$refs[this.queue.subtype];
            subcomponent.prepareForSave();
          }

 
          var node = {
            object: this.queue,
            type: "queue"
          };
          this.isLoading = true;
          var result = await this.$store.dispatch("nodeStore/updateNode", {node: node});
          this.isLoading = false;
          if (result.data.success) {
            var updated = {
              type: "queue",
              object: result.data.node
            };
            this.hide();
            this.$emit("updatedNode", updated);
          } 
          else {
            this.modalMessage = result.data.error;
            this.modalMessageClass = "agModal-errorMessage";
          }
        },

        deleteButton_click() {
          this.$refs.deleteModal.show();
        },

        async confirmDeleteButton_click() {
          this.$refs.deleteModal.hide();
          var node = {
            object: this.queue,
            type: "queue"
          };
          this.isLoading = true;
          var result = await this.$store.dispatch("nodeStore/deleteNode", {node: node});
          this.$emit("deletedNode", node);
          this.isLoading = false;
          this.hide();    
        },

        // other
        async show(){
          await this.setQueue();
          await Vue.nextTick();
          await this.reset();
          this.$modal.show("agQueueModal");
        },

        hide() {
          this.$modal.hide('agQueueModal');
        },

        async reset() {
            this.modalMessage = "";
            this.modalMessageClass = "";
            this.errorField = "";
            if (!this.queue.config)
              this.queue.config = {};

            var subcomponent = this.$refs[this.queue.subtype];
            if (subcomponent) 
              subcomponent.reset();
        },

      async setQueue() {
        if(this.node && this.node.type == "queue") 
          this.queue = this.workflow.queues.find((object) => object._id == this.node.object._id);
        else
          this.queue = null;
      },
        
    }
}
</script>


<style scoped lang="css">

#agQueueModal-typeDescription {
  max-width: 50%;
}

</style>




// WEBPACK FOOTER //
// src/components/nodes/queues/QueueModal.vue